import {Component, inject, Input, OnInit, ViewChild} from '@angular/core';
import {SearchLocationComponent} from '../search-location/search-location.component';
import {SearchMultiSelectComponent} from '../search-multi-select/search-multi-select.component';
import {SalesOfferStoreService} from '../../../store/sales-offer/sales-offer-store.service';
import {first} from 'rxjs/operators';
import {SystemSettingsService} from '../../../service/system-settings.service';
import * as SearchActions from '../../../store/search/search.actions';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../store/app.reducers';
import * as EnforcedAuctionOfferAction from '../../../store/enforced-auction-offer/enforced-auction-offer.actions';

@Component({
  selector: 'ucs-search-channel-country-variant',
  templateUrl: './search-channel-country-variant.component.html',
  styleUrls: ['./search-channel-country-variant.component.scss', '../../sidebar-template/sidebar-template.component.scss'],
  standalone: false
})
export class SearchChannelCountryVariantComponent implements OnInit {
  @Input() channels: any;
  @Input() countries: any;
  @Input() searchParams: any;
  @Input() isPiaAuctionScope: any;
  @Input() searchLocation: SearchLocationComponent;
  @ViewChild('dropdownCountry') dropdownCountry: SearchMultiSelectComponent;
  @ViewChild('dropdownChannel') dropdownChannel: SearchMultiSelectComponent;

  ucs636active: boolean;

  readonly salesOfferStoreService = inject(SalesOfferStoreService);
  readonly systemSettingsService = inject(SystemSettingsService);
  readonly store = inject(Store<fromRoot.AppState>);

  ngOnInit(): void {
    this.systemSettingsService
      .isSystemFeatureActivatedForAnyChannel('UCS_636_STANDARDIZED_SALES_SIDEBAR_FILTER')
      .pipe(first())
      .subscribe(isFeatureActive => {
        this.ucs636active = isFeatureActive;
      });
  }

  onChangeSearchParamChannels(value: DistributionChannel[]) {
    this.searchParams.channels = value;
    this.updateParamsAndAggregations();
  }

  onChangeSearchParamCountry(value: Country[]) {
    this.searchParams.countries = value;
    // when a country is selected, zipcode & city needs to be reset
    this.searchParams.zipCode = undefined;
    this.searchParams.city = undefined;

    this.updateParamsAndAggregations();
  }

  overrideCountries(searchParams: any) {
    this.dropdownCountry?.overrideSelection(searchParams);
  }

  overrideChannels(searchParams: any) {
    this.dropdownChannel?.overrideSelection(searchParams);
  }

  /**
   * Updates vehicle-related search params and dispatch update in redux store
   */
  onChangeVehiclesSearchParams(vehicleParams: VehicleOfferSearchParams) {
    this.searchParams.brand = vehicleParams.brand;
    this.searchParams.brand2 = vehicleParams.brand2;
    this.searchParams.brand3 = vehicleParams.brand3;
    this.searchParams.brand4 = vehicleParams.brand4;
    this.searchParams.brand5 = vehicleParams.brand5;
    this.searchParams.models = vehicleParams.models;
    this.searchParams.models2 = vehicleParams.models2;
    this.searchParams.models3 = vehicleParams.models3;
    this.searchParams.models4 = vehicleParams.models4;
    this.searchParams.models5 = vehicleParams.models5;
    this.searchParams.modelVariants = vehicleParams.modelVariants;
    this.searchParams.modelVariants2 = vehicleParams.modelVariants2;
    this.searchParams.modelVariants3 = vehicleParams.modelVariants3;
    this.searchParams.modelVariants4 = vehicleParams.modelVariants4;
    this.searchParams.modelVariants5 = vehicleParams.modelVariants5;

    this.updateParamsAndAggregations();
  }

  updateParamsAndAggregations() {
    if (this.isPiaAuctionScope) {
      this.store.dispatch(new EnforcedAuctionOfferAction.UpdateSearchParamsAction(this.searchParams));
      this.store.dispatch(new EnforcedAuctionOfferAction.UpdateSearchAggregationAction());
    } else if (this.ucs636active) {
      this.salesOfferStoreService.updateSearchParamsAndAggregationsForCurrentScope(this.searchParams);
    } else {
      this.store.dispatch(new SearchActions.UpdateSearchParamsAction(this.searchParams));
      this.store.dispatch(new SearchActions.UpdateSearchAggregationAction());
    }
  }
}
